export class UncaughtErrorsHandler {
    private _callback: any;
    private _listening: boolean;

    /**
     * Create a uncaughtErrorsHandler object.
     * @param {Function} callback - The callback which is called after an occured error event.
     * @param {Boolean} startListening - Chose if the object should start listening immediately.
     */
    constructor(callback, startListening = true) {
        if (!callback) {
            throw new Error("Missing callback function");
        }

        this._callback = callback;
        this._listening = false;

        if (startListening) {
            this._setupEvents();
        }
    }

    /**
     * Start listening for error events.
     * @return {void}
     */
    startListening() {
        if (!this._listening) {
            this._setupEvents();
        }
    }

    /**
     * Stop listening for error events.
     * @return {void}
     */
    stopListening() {
        if (this._listening) {
            this._setupEvents(false);
        }
    }

    /**
     * Disposing the class so there would be no memory leak.
     * @return {void}
     */
    dispose() {
        if (this._listening) {
            this._setupEvents(false);
        }

        this._callback = null;
    }

    /**
     * It will attatch or detatch the listening event based on the given parametter;
     * @param {Boolean} attatch - if true the object will start listening.
     * @return {void}
     */
    _setupEvents(attatch = true) {
        this._listening = attatch ? true : false;

        if (attatch) {
            if (typeof window !== "undefined") {
                window.addEventListener("error", this._callback);
            }
        } else {
            if (typeof window !== "undefined") {
                window.removeEventListener("error", this._callback);
            }
        }
    }
}
